import React, { useCallback, useContext, useState } from 'react'
import { Col } from '@desenvolvimento-intuix/ui-grid-system'

import { TabsContext } from '../../../contexts/tabs'

import { HeaderToggle } from './HeaderToggle'

import * as S from './styles'

export const Header = () => {
  const { currentIndex, onGotoTab, isCurrentTab, isDisabled, props } =
    useContext(TabsContext)

  const [toggle, setToggle] = useState(false)

  const renderHeader = useCallback(() => {
    return props.render.map(({ title, disabled, status }, index) => (
      <Col key={index}>
        <S.Head
          {...{
            className: `tabs-head ${isCurrentTab(currentIndex, index)} ${
              status || ''
            } ${isDisabled(disabled)}`,
            onClick: () => {
              onGotoTab(index)

              setToggle(false)
            }
          }}
        >
          <h1>{title}</h1>
        </S.Head>
      </Col>
    ))
  }, [props.render, currentIndex])

  const onToggle = () => {
    setToggle(!toggle)
  }

  return (
    <S.Header>
      <HeaderToggle
        {...{
          toggle,
          onToggle,
          selectedTitle: props.render[currentIndex].title
        }}
      />
      <S.HeaderMenuWrapper>
        <S.HeaderMenu {...{ toggle }}>{renderHeader()}</S.HeaderMenu>
      </S.HeaderMenuWrapper>
    </S.Header>
  )
}
